import React from "react";
import styles from "./styles.css";
import { FRANCHISE_WHY_CARS } from "./selector";

const FranchiseWhyCars = () => {
    return (
        <div styleName={"styles.whyFranchise"}>
            <h2>Why CARS24 franchise?</h2>
            <ul>
                {FRANCHISE_WHY_CARS.map(({ icon, title, subTitle, description }) => {
                    return (
                        <li key={title}>
                            <img src={icon} height={30} width={30} alt={title} loading="lazy" fetchpriority={"low"} />
                            <h3>{title} <span>{subTitle}</span></h3>
                            <p>{description}</p>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default FranchiseWhyCars;
